export default {
  admin: {
    help_settings: "Hilfe-Einstellungen",
    help_settings_success: "Hilfe-Einstellungen erfolgreich geändert!",
    lastEmail: "Link der letzten gesendeten E-Mail",
    generatePassword: "Passwort neu generieren und senden",
    switchUser: "{name} verkörpern",
    switchAdmin: "Sie verkörpern",
    modify: "{title} bearbeiten",
    show: "{title} anzeigen",
    delete: "{title} löschen",
    add: "Hinzufügen",
    name: "Name",
    title: "Titel",
    year: "Jahr",
    trainingOpeningStart: "Beginn der Ausbildungsöffnungen",
    trainingOpeningEnd: "Ende der Ausbildungsöffnungen",
    level: "Niveau",
    registrationDate: "Registrierungsdatum",
    active: "Aktiv",
    activateOption: "Aktivieren/Deaktivieren",
    management_of: "Verwaltung von",
    contents: "Inhalte",
    users: "Benutzer",
    trainings: "Ausbildungen",
    archiving: {
      title: "Archivierung",
      action: "Archivieren",
      archive_confirmation: "Möchten Sie diese Gruppen wirklich archivieren?",
      active_confirmation: "Möchten Sie diese Gruppen wirklich dearchivieren?",
      archive_success: "Gruppen erfolgreich archiviert!",
      active_success: "Gruppen erfolgreich dearchiviert!",
    },
    current_training_course_year: {
      title: "Aktuelles Jahr ändern",
      error: "Das Referenzjahr muss sich vom neuen aktuellen Jahr unterscheiden",
      confirmation: {
        title: "Möchten Sie das aktuelle Jahr wirklich ändern?",
        subtitle: "Es wird bei allen Gruppen geändert, die das Referenzjahr als Startjahr haben",
      },
      success: ({ named }) => `Aktuelles Jahr auf ${named("count")} Gruppen geändert`,
    },
    modules: "Module",
    module: "Modul",
    code: "Code",
    error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut!",
    lastName: "Nachname",
    firstName: "Vorname",
    profile: "Profil",
    embody: "Verkörpern",
    visible: "Sichtbar",
    popup: "Popup",
    visibleHomeLea: "Sichtbar",
    endDate: "Enddatum",
    startDate: "Startdatum",
    contractTypeColor: "Vertragsfarbe",
    none_duplicated_user: "Kein Benutzer zum Zusammenführen",
    skill: {
      title: ({ plural }) => plural(["Kompetenz", "Kompetenzen"]),
    },
    skillCategory: {
      title: "Kategorie",
    },
    skill_session: {
      generate: "Zeiträume generieren",
      empty:
        "Sie müssen in der Modulkonfiguration eine Anzahl zu erstellender Zeiträume angeben, bevor Sie diese konfigurieren können",
      generation_success: "Zeiträume erfolgreich generiert",
      existing_session: "Sie sind dabei, bestehende Zeiträume zu löschen. Sind Sie sicher?",
    },
    skillReferential: {
      title: "Kompetenzreferential",
      edit: "Referential bearbeiten",
    },
    skill_import_france_competence: {
      title: "Alle France Compétences-Referentiale importieren",
      confirm: "Möchten Sie wirklich alle France Compétences-Referentiale laden?",
      success: "Referentiale erfolgreich importiert!",
    },
    navigation: {
      users: "Benutzer",
      trainings: "Ausbildungen",
      modules: "Module",
      settings: "Konfiguration",
      general: "Allgemein",
      steering: "Steuerung",
    },
    home: {
      title: "Allgemeine Konfiguration",
      title2: "Übersicht",
      title3: "Automatische Synchronisation",
      title4: "Allgemeine Statistiken",
      active: "Aktiviert",
      unique_connection: "Einmalige Verbindung",
      apprentices_mentor: "Auszubildende und Mentoren",
    },
    log: {
      title: ({ plural }) => plural(["Log", "Logs"]),
      view: "Geänderte Daten anzeigen",
      modify_field: "Geändertes Feld",
      old_data: "Alte Daten",
      data: "Neue Daten",
    },
    ypareoReporting: {
      title: ({ plural }) => plural(["Ypareo-Bericht", "Ypareo-Berichte"]),
      view: "Bericht anzeigen",
    },
    edusignReporting: {
      title: ({ plural }) => plural(["Edusign-Bericht", "Edusign-Berichte"]),
    },
    registrationAlert: {
      title: ({ plural }) => plural(["Warnung", "Warnungen"]),
    },
    ammonReporting: {
      title: ({ plural }) => plural(["Ammon-Bericht", "Ammon-Berichte"]),
    },
    report: {
      title: ({ plural }) => plural(["Bericht", "Berichte"]),
    },
    mail: {
      title: ({ plural }) => plural(["E-Mail", "E-Mails"]),
      view: "E-Mail-Inhalt anzeigen",
      recipient: "Empfänger:",
      status: "Sendestatus:",
      sent_on: "Gesendet am:",
      open_on: "Geöffnet am:",
    },
    registrationField: {
      title: ({ plural }) => plural(["Feld", "Felder"]),
    },
    registrationBlock: {
      title: ({ plural }) => plural(["Block", "Blöcke"]),
    },
    registrationTab: {
      title: ({ plural }) => plural(["Reiter", "Reiter"]),
    },
    registrationStep: {
      title: ({ plural }) => plural(["Schritt", "Schritte"]),
    },
    registrationDataVersion: {
      title: ({ plural }) => plural(["Version", "Versionen"]),
      notEmpty: "Formulare sind bereits dieser Version zugeordnet",
    },
    registrationDevice: {
      title: ({ plural }) => plural(["Gerät", "Geräte"]),
    },
    registrationDataConfiguration: "Versionskonfiguration bearbeiten",
    cerfaParam: {
      title: ({ plural }) => plural(["CERFA-Konfiguration", "CERFA-Konfigurationen"]),
    },
    role: {
      title: ({ plural }) => plural(["Rolle", "Rollen"]),
    },
    triad: {
      title: ({ plural }) => plural(["Trinôme", "Trinômes"]),
      delete_all_triad: {
        title: "Alle Trinômes löschen",
        confirmation: "Möchten Sie alle Trinômes dieser Gruppe wirklich löschen?",
        success: "Trinômes erfolgreich gelöscht!",
      },
    },
    studeaUser: {
      title: ({ plural }) => plural(["Benutzer", "Benutzer"]),
    },
    user: {
      title: ({ plural }) => plural(["Benutzer", "Benutzer"]),
      actions: {
        keep_user: "Behalten",
        delete_user: "Löschen",
        unselect_user: "Diesen Benutzer abwählen",
        reset_password: {
          success: "Der Link zum Zurücksetzen des Passworts wurde erfolgreich an den Benutzer gesendet!",
        },
      },
      add_profile: "Profil hinzufügen",
      warning_profile: "Profil löschen",
      warning_profile_text: "Möchten Sie dieses Profil wirklich löschen?",
      last_connection: "Letzte Verbindung am: \n",
      search_user_by_name_or_mail: "Benutzer nach Name oder E-Mail suchen",
      import_users: "Benutzer importieren",
      profile_config: "Profilkonfiguration",
      merge: "Benutzer zusammenführen",
      duplicated_user_count: "doppelte Benutzer zum Zusammenführen",
      merge_duplicated_user_confirmation: "Möchten Sie diese Benutzer wirklich zusammenführen?",
      merge_success: "Zusammenführung erfolgreich durchgeführt",
      no_double_user: "Keine Duplikate gefunden",
      mail_address: "E-Mail-Adresse",
      already_connected: "Hat sich bereits im Heft angemeldet",
      yes: "Ja",
      no: "Nein",
      row: "Zeile",
      reference_user: "Referenzbenutzer",
      duplicated_user: "Duplikate",
      reset_choices: "Auswahl zurücksetzen",
      options: "Optionen",
      account_creation: "Kontoerstellung",
      username: "Kennung",
      external_id: "Externe ID",
      birth_date: "Geburtsdatum",
      send_credential_back_to_user: "Anmeldedaten erneut an den betreffenden Benutzer senden",
      reference_user_is_not_duplicate: "Der Referenzbenutzer ist kein Duplikat",
      keep: "Behalten",
      delete: "Löschen",
      export: "Exportieren",
      send: "Speichern",
      profile_title: "Bezeichnungen der Benutzerprofile",
      users_profile_title_list: "Liste der Benutzerprofilbezeichnungen",
      modify_profile: "Bezeichnung bearbeiten",
      modification_succes: "Profil erfolgreich bearbeitet",
      no_mail_title: "Kein Link",
      no_mail: "Dieser Benutzer hat noch keinen Link zum Zurücksetzen seines Passworts erhalten!",
      profile_user_info:
        "Erstellen Sie verschiedene Pilotprofile mit spezifischen Rechten, die danach den Benutzern zugewiesen werden können. Beispiel: Anwesenheitsverwalter, pädagogisch Verantwortlicher, ….",
      role: {
        NONE: "Nein",
        ALL: "Ja",
        VIEW: "Anzeigen",
        EDIT: "Bearbeiten",
        DELETE: "Löschen",
      },
      erase_studeaManager_profile:
        "Achtung: Sie sind dabei, das/die Ihrem Konto zugeordnete(n) Pilotprofil(e) zu löschen",
    },
    profile_label: {
      titleAbbreviation: "Abkürzung",
      titlePlural: "Titel im Plural",
      titleWithArticle: "Titel mit Artikel",
    },
    training: {
      title: ({ plural }) => plural(["Ausbildung", "Ausbildungen"]),
      ufa_add_test: "Test-Ausbildung erstellen",
      genere_triad_test: "Test-Trinômes generieren",
      generate_triad_test_confirmation: "Möchten Sie wirklich Test-Trinômes für alle Ausbildungen erstellen?",
      genere_triad_test_success: "Test-Trinômes erfolgreich erstellt!",
      genere_training_test_success: "Test-Ausbildung erfolgreich erstellt!",
      import_triad: "Trinômes importieren",
      confirmation_subtitle: "Diese Löschung führt auch zur Löschung der mit dieser Ausbildung verknüpften Gruppen",
    },
    modele: {
      title: ({ plural }) => plural(["Vorlage", "Vorlagen"]),
    },
    variable: {
      title: ({ plural }) => plural(["Variable", "Variablen"]),
    },
    registration: {
      title: ({ plural }) => plural(["Anmeldung", "Anmeldungen"]),
    },
    trainingCourse: {
      title: ({ plural }) => plural(["Gruppe", "Gruppen"]),
      duplicate_on_next_year: "Gruppe auf das nächste Jahr duplizieren",
      duplicate: "Gruppe duplizieren",
      delete: "Gruppe löschen",
    },
    copy: {
      success: ({ plural, named }) =>
        plural([`${named("name")} erfolgreich kopiert!`, `${named("name")} erfolgreich kopiert!`]),
      title: ({ plural, named }) =>
        plural([`Dieses/n ${named("name")} kopieren`, `Dieses/n ${named("name")} kopieren`]),
      sub_title: ({ plural, named }) =>
        plural([
          `Möchten Sie dieses/n ${named("name")} wirklich kopieren?`,
          `Möchten Sie dieses/n ${named("name")} wirklich kopieren?`,
        ]),
    },
    studeaManager: {
      title: ({ plural }) => plural(["Pilot", "Piloten"]),
    },
    design: {
      title: "Gestaltung",
    },
    dataAgreement: {
      title: ({ plural }) => plural(["Datenschutzrichtlinie", "Datenschutzrichtlinien"]),
    },
    institution: {
      title: ({ plural }) => plural(["Einrichtung", "Einrichtungen"]),
      list: {
        title: "Die aktiven Einrichtungen",
      },
      export: {
        title: "Antworten auf Fragebögen des Vorjahres",
      },
    },
    document: {
      title: ({ plural }) => plural(["Öffentliches Dokument", "Öffentliche Dokumente"]),
    },
    documentCategory: {
      title: ({ plural }) => plural(["Dokumentenkategorie", "Dokumentenkategorien"]),
    },
    helpDocument: {
      title: ({ plural }) => plural(["Online-Hilfe", "Online-Hilfen"]),
    },
    component: {
      title: ({ plural }) => plural(["Komponente", "Komponenten"]),
      export: {
        title: "Antworten auf Fragebögen des Vorjahres",
      },
    },
    degree: {
      title: ({ plural }) => plural(["Abschlussart", "Abschlussarten"]),
    },
    contractType: {
      title: ({ plural }) => plural(["Vertragsart", "Vertragsarten"]),
    },
    planContract: {
      title: ({ plural }) => plural(["Ausbildungsjahr", "Ausbildungsjahre"]),
      actions: {
        activate: {
          title: "Aktivieren",
          success: "Ausbildungsjahr erfolgreich aktiviert!",
        },
        activate_recruitment: {
          title: "Für die Rekrutierung aktivieren",
          success: "Für die Rekrutierung erfolgreich aktiviert!",
        },
      },
    },
    titleRncp: {
      title: ({ plural }) => plural(["RNCP-Titel", "RNCP-Titel"]),
    },
    modulet: {
      title: ({ plural }) => plural(["Modul", "Module"]),
      list: {
        title: "Modulverwaltung",
      },
      trainingCourse: {
        edit: {
          title: "Mit dem Modul verknüpfte Ausbildungen bearbeiten",
          success: "Mit dem Modul verknüpfte Ausbildungen erfolgreich geändert!",
        },
        displayActive: "Nur mit dem Modul verknüpfte Ausbildungen anzeigen",
      },
      config: {
        title: "Modulkonfiguration",
      },
      skill_session: {
        title: "Zeiträume generieren",
      },
      registration: {
        title: "Anmeldungs-Dashboard",
      },
      skill_referential: {
        title: "Kompetenzreferential",
        list: "Die Referentiale",
        edit: "Referential bearbeiten",
        config: "Modulkonfiguration",
      },
    },
    template: {
      title: ({ plural }) => plural(["Vorlage", "Vorlagen"]),
      success: "Vorlage erfolgreich geändert!",
      duplicate: "Diese Vorlage duplizieren",
      default_template: "Standardvorlage",
    },
    absenceReason: {
      title: ({ plural }) => plural(["Abwesenheitsgrund", "Abwesenheitsgründe"]),
    },
    questionnaireConfig: {
      title: "Fragebogenmodul-Konfiguration",
      multiple_actions: "Fragebögen bearbeiten",
      action_to_do: "Durchzuführende Aktionen",
      warning:
        "Diese Aktion führt zur Änderung aller Fragebögen des ausgewählten Jahres mit dem ausgewählten Titel. Leer gelassene Felder werden nicht geändert",
      confirmation: "Möchten Sie diese Daten wirklich ändern?",
      success: "Fragebögen erfolgreich geändert!",
    },
    ypareoConfig: {
      title: "Ypareo-Modulkonfiguration",
      get_directories: "Ypareo-Verzeichnisse abrufen",
    },
    driverLicenceConfig: {
      title: "Führerschein-B-Modulkonfiguration",
    },
    studeaManagerProfile: {
      title: ({ plural }) => plural(["Pilotprofil", "Pilotprofile"]),
      all_access: "Alle Berechtigungen aktivieren",
    },
    historic: {
      title: "Verlauf",
    },
    statistic: {
      title: "Statistiken",
      general: "Allgemein",
      questionnaires: "Fragebögen",
      absence: "Abwesenheiten",
      course: "Kursverfolgung",
      global_export: "Statistiken exportieren",
      updated_on: "aktualisiert am",
      indicators_generated: "Ergänzende Indikatoren werden generiert",
    },
    export: {
      title: "Die Exporte",
      year: "Die Gruppen",
      available_exports: "Verfügbare Exporte",
      signature_questionnaire_all: "Fragebogenunterschriften aller Abschlüsse exportieren",
      absence_cumulate_by_diploma: "Kumulierte Abwesenheiten nach Abschluss exportieren",
      absence_by_apprentice: "Abwesenheiten nach Auszubildenden exportieren",
      company_visits: "Unternehmensbesuche exportieren",
      contract: "Verträge exportieren",
      dashboard: "Verlaufsdashboard exportieren",
      summary_table: "Zusammenfassungstabelle exportieren",
      questionnaire: "Fragebogen exportieren",
    },
    duplicate: {
      title: "Duplikationen",
    },
    archive: {
      title: "Archivierung",
    },
    news: {
      title: ({ plural }) => plural(["Neuigkeit", "Neuigkeiten"]),
      news_list: "Liste der Neuigkeiten",
      list: {
        title: "Neuigkeiten",
        uploaded_date: "Online gestellt am",
        see_more: "Mehr anzeigen",
        see_all_news: "Alle Neuigkeiten anzeigen",
        go_back_newslist: "Zurück zur Liste der Neuigkeiten",
      },
    },
    import: {
      modele: "Herunterzuladende Dateivorlage",
      triad_new_file:
        "Achtung: Eine neue Vorlage ist seit dem 18.09.2023 verfügbar.\n" +
        "          Bitte laden Sie diese herunter und verwenden Sie sie, um Ihre Trinômes hochzuladen.",
      triad_update:
        "Achtung: Es werden nur fehlende Mitglieder eines Trinômes aktualisiert. Keine Daten (Nachname, Vorname oder E-Mail) eines bestehenden Benutzers werden aktualisiert.",
      thanks: "Bitte ändern und/oder löschen Sie die Spalten der Vorlage nicht",
      contract_type_id: "Vertragsart-IDs (Spalte AM)",
    },
    text: "Text",
    dateToDisplay: "Anzuzeigendes Datum",
    emailContent: "E-Mail-Inhalt",
    picture: "Bild",
    subTitle: "Untertitel",
    tag: "Tag",
    video: "Video",
    activate_notification: "Benachrichtigungen aktivieren",
    activate_notification_success: "Benachrichtigungseinstellung aktualisiert",
    tutorial: {
      title: ({ plural }) => plural(["Studea-Tutorial", "Studea-Tutorials"]),
      admin: "Admin",
      studea_manager: "Pilot",
      user: "Benutzer",
    },
    ammonConfig: {
      title: "Ammon-Modulkonfiguration",
      synchronisation: "Synchronisation",
      confirmation: "Möchten Sie die Synchronisation mit Ammon wirklich starten?",
    },
    contractRuptureConfig: {
      title: "Erklärung von Vertragsauflösungen durch den Auszubildenden oder das Unternehmen",
    },
    reporting: {
      list: ({ named }) => `Die ${named("name")}-Berichte`,
    },
  },
};
